<template>
  <div class="page">
    <div class="page-content">
      <div class="V_mj6kdogj__components_FeedsWrapperV2 V_mj6kdogj__floors_CommonRanking_components_PC_CardList">
        <div class="rankingCard"><div class="left"><div class="ico wide top1"><div class="text-top">榜首21天</div></div><img src="../assets/images/hot/1aab0f06-fd72-4cc4-ae08-38b94bbd7878.png" class="V_mj6kdogj__components_LazyImageDiv sku-img"/><div class="lineOne"><div class="icon"></div><div class="text1 withText2">10万人买过</div><div class="text2">15日售出超2000件</div></div></div><div class="right"><div class="sku-title two-text-ellipsis"><img class="tag" alt="" src="https://img10.360buyimg.com/img/jfs/t1/321439/15/7030/1723/68429e0fFb265ee7e/c5483a77610a8901.png">百子衣冰箱贴</div><div class="main-info-area"><div class="V_mj6kdogj__floors_CommonRanking_components_PC_CardList_Slider main-info-multi-line"><div class="pos"><div class="V_mj6kdogj__components_VisibleWrapper"></div></div><div class="child animate"><div class="second-line usercomment"><div class="user-right"><div class="avatar" style="background-image: url(&quot;undefined&quot;);"></div><div class="numtext">58人评价</div><div class="cmt-ico">“</div><div class="comment">好看</div><div class="cmt-ico">”</div></div></div></div><div class="child animate"></div></div></div>
          <div class="price-area black"><div class="main-price"><div class="main-price-int">79</div><div class="main-price-float">.00</div>
          </div></div></div></div>
        <div class="rankingCard"><div class="left"><div class="ico wide top2"><div class="text-top">前三21天</div></div><img src="../assets/images/hot/3fed7836-e7fe-405e-b4c8-665b702dee26.png" class="V_mj6kdogj__components_LazyImageDiv sku-img"/><div class="lineOne"><div class="icon"></div><div class="text1 withText2">5万人买过</div><div class="text2">15日售出超500件</div></div></div><div class="right"><div class="sku-title two-text-ellipsis"><img class="tag" alt="" src="https://img10.360buyimg.com/img/jfs/t1/321439/15/7030/1723/68429e0fFb265ee7e/c5483a77610a8901.png">皮弁冠冰箱贴</div><div class="main-info-area"><div class="V_mj6kdogj__floors_CommonRanking_components_PC_CardList_Slider main-info-multi-line"><div class="pos"><div class="V_mj6kdogj__components_VisibleWrapper"></div></div><div class="child animate"><div class="second-line usercomment"><div class="user-right"><div class="avatar" style="background-image: url(&quot;undefined&quot;);"></div><div class="numtext">28人评价</div><div class="cmt-ico">“</div><div class="comment">好看</div><div class="cmt-ico">”</div></div></div></div><div class="child animate"></div></div></div>
          <div class="price-area black"><div class="main-price"><div class="main-price-int">79</div><div class="main-price-float">.00</div>
          </div></div></div></div>
        <div class="rankingCard"><div class="left"><div class="ico wide top3"><div class="text-top">前三19天</div></div><img src="../assets/images/hot/9b58fb70-7476-47b8-91bd-e6295d586b68.png" class="V_mj6kdogj__components_LazyImageDiv sku-img"/><div class="lineOne"><div class="icon"></div><div class="text1 withText2">10万人买过</div><div class="text2">15日售出超500件</div></div></div><div class="right"><div class="sku-title two-text-ellipsis"><img class="tag" alt="" src="https://img10.360buyimg.com/img/jfs/t1/321439/15/7030/1723/68429e0fFb265ee7e/c5483a77610a8901.png">乌纱翼善冠冰箱贴</div><div class="main-info-area"><div class="V_mj6kdogj__floors_CommonRanking_components_PC_CardList_Slider main-info-multi-line"><div class="pos"><div class="V_mj6kdogj__components_VisibleWrapper"></div></div><div class="child animate"><div class="second-line usercomment"><div class="user-right"><div class="avatar" style="background-image: url(&quot;undefined&quot;);"></div><div class="numtext">15人评价</div><div class="cmt-ico">“</div><div class="comment">好看</div><div class="cmt-ico">”</div></div></div></div><div class="child animate"></div></div></div>
          <div class="price-area black"><div class="main-price"><div class="main-price-int">79</div><div class="main-price-float">.00</div>
          </div></div></div></div>
        <div class="rankingCard"><div class="left"><div class="ico top-num"><div class="text-top place"></div><div class="text-num">4</div></div><img src="../assets/images/hot/47e502f6-594d-42cb-b0ee-849fc0d7d0b4.png" class="V_mj6kdogj__components_LazyImageDiv sku-img"/><div class="lineOne"><div class="icon"></div><div class="text1 withText2">5万人买过</div><div class="text2">15日售出超500件</div></div></div><div class="right"><div class="sku-title two-text-ellipsis"><img class="tag" alt="" src="https://img10.360buyimg.com/img/jfs/t1/321439/15/7030/1723/68429e0fFb265ee7e/c5483a77610a8901.png">十二龙九凤金属冰箱贴</div><div class="main-info-area"><div class="V_mj6kdogj__floors_CommonRanking_components_PC_CardList_Slider main-info-multi-line"><div class="pos"><div class="V_mj6kdogj__components_VisibleWrapper"></div></div><div class="child animate"><div class="second-line usercomment"><div class="user-right"><div class="avatar" style="background-image: url(&quot;undefined&quot;);"></div><div class="numtext">20人评价</div><div class="cmt-ico">“</div><div class="comment">物流速度快</div><div class="cmt-ico">”</div></div></div></div><div class="child animate"><div class="second-line"><div class="sell-points">修护牙龈屏障 · 7天快速舒缓 · 专业全能</div></div></div></div></div>
          <div class="price-area black"><div class="main-price"><div class="main-price-int">128</div><div class="main-price-float">.00</div>
          </div></div></div></div>
        <div class="rankingCard"><div class="left"><div class="ico top-num"><div class="text-top place"></div><div class="text-num">5</div></div><img src="../assets/images/hot/317fede5-563d-4f74-8017-90367c99e3c2.png" class="V_mj6kdogj__components_LazyImageDiv sku-img"/><div class="lineOne"><div class="icon"></div><div class="text1 withText2">10万人买过</div><div class="text2">15日售出超200件</div></div></div><div class="right"><div class="sku-title two-text-ellipsis"><img class="tag" alt="" src="https://img10.360buyimg.com/img/jfs/t1/321439/15/7030/1723/68429e0fFb265ee7e/c5483a77610a8901.png">十二龙九凤金属冰箱贴</div><div class="main-info-area"><div class="V_mj6kdogj__floors_CommonRanking_components_PC_CardList_Slider main-info-multi-line"><div class="pos"><div class="V_mj6kdogj__components_VisibleWrapper"></div></div><div class="child animate"><div class="second-line usercomment"><div class="user-right"><div class="avatar" style="background-image: url(&quot;undefined&quot;);"></div><div class="numtext">20人评价</div><div class="cmt-ico">“</div><div class="comment">好看</div><div class="cmt-ico">”</div></div></div></div><div class="child animate"><div class="second-line"><div class="sell-points">智能APP指导 · 智臻洁净刷头 · 12种洁齿模式</div></div></div></div></div>
          <div class="price-area black"><div class="main-price"><div class="main-price-int">128</div><div class="main-price-float">.00</div>
          </div></div></div></div>
        <div class="rankingCard"><div class="left"><div class="ico top-num"><div class="text-top place"></div><div class="text-num">6</div></div><img src="../assets/images/hot/880cc6b0-993b-4de0-a0a6-200e545e85ff.png" class="V_mj6kdogj__components_LazyImageDiv sku-img"/><div class="lineOne"><div class="icon"></div><div class="text1 withText2">10万人买过</div><div class="text2">15日售出超200件</div></div></div><div class="right"><div class="sku-title two-text-ellipsis"><img class="tag" alt="" src="https://img10.360buyimg.com/img/jfs/t1/321439/15/7030/1723/68429e0fFb265ee7e/c5483a77610a8901.png">又梨入画如梦·卷系列手办盲盒</div><div class="main-info-area"><div class="V_mj6kdogj__floors_CommonRanking_components_PC_CardList_Slider main-info-multi-line"><div class="pos"><div class="V_mj6kdogj__components_VisibleWrapper"></div></div><div class="child animate"><div class="second-line usercomment"><div class="user-right"><div class="avatar" style="background-image: url(&quot;undefined&quot;);"></div><div class="numtext">18人评价</div><div class="cmt-ico">“</div><div class="comment">好看</div><div class="cmt-ico">”</div></div></div></div><div class="child animate"><div class="second-line"><div class="sell-points">12种洁齿体验 · 智能APP · 3天5倍去渍</div></div></div></div></div>
          <div class="price-area black"><div class="main-price"><div class="main-price-int">79</div><div class="main-price-float">.00</div>
          </div></div></div></div>
        <div class="rankingCard"><div class="left"><div class="ico top-num"><div class="text-top place"></div><div class="text-num">7</div></div><img src="../assets/images/hot/a45a6485-7bf8-40b6-b915-a88c37ddb81e.png" class="V_mj6kdogj__components_LazyImageDiv sku-img"/><div class="lineOne"><div class="icon"></div><div class="text1 withText2">1万人买过</div><div class="text2">15日售出超200件</div></div></div><div class="right"><div class="sku-title two-text-ellipsis"><img class="tag" alt="" src="https://img10.360buyimg.com/img/jfs/t1/321439/15/7030/1723/68429e0fFb265ee7e/c5483a77610a8901.png">仅你好运金榜题名冰箱贴</div><div class="main-info-area"><div class="V_mj6kdogj__floors_CommonRanking_components_PC_CardList_Slider main-info-multi-line"><div class="pos"><div class="V_mj6kdogj__components_VisibleWrapper"></div></div><div class="child animate"><div class="second-line usercomment"><div class="user-right"><div class="avatar" style="background-image: url(&quot;undefined&quot;);"></div><div class="numtext">60人评价</div><div class="cmt-ico">“</div><div class="comment">好看</div><div class="cmt-ico">”</div></div></div></div><div class="child animate"><div class="second-line"><div class="sell-points">智能控压护龈 · 进口双马达 · 悬浮充电</div></div></div></div></div>
          <div class="price-area black"><div class="main-price"><div class="main-price-int">118</div><div class="main-price-float">.00</div>
          </div></div></div></div>
        <div class="rankingCard"><div class="left"><div class="ico top-num"><div class="text-top place"></div><div class="text-num">8</div></div><img src="../assets/images/hot/b0c864c7-ae55-49c9-aa10-d471960ddc08.png" class="V_mj6kdogj__components_LazyImageDiv sku-img"/><div class="lineOne"><div class="icon"></div><div class="text1 withText2">10万人买过</div><div class="text2">15日售出超200件</div></div></div><div class="right"><div class="sku-title two-text-ellipsis"><img class="tag" alt="" src="https://img10.360buyimg.com/img/jfs/t1/321439/15/7030/1723/68429e0fFb265ee7e/c5483a77610a8901.png">大明风华灯笼金属冰箱贴</div><div class="main-info-area"><div class="V_mj6kdogj__floors_CommonRanking_components_PC_CardList_Slider main-info-multi-line"><div class="pos"><div class="V_mj6kdogj__components_VisibleWrapper"></div></div><div class="child animate"><div class="second-line usercomment"><div class="user-right"><div class="avatar" style="background-image: url(&quot;undefined&quot;);"></div><div class="numtext">40人评价</div><div class="cmt-ico">“</div><div class="comment">好看</div><div class="cmt-ico">”</div></div></div></div><div class="child animate"><div class="second-line"><div class="sell-points">智能互动屏 · 牙医共研真护龈 · 智能压力感应</div></div></div></div></div>
          <div class="price-area black"><div class="main-price"><div class="main-price-int">49</div><div class="main-price-float">.00</div>
          </div></div></div></div>
        <div class="rankingCard Fill_Flex_Cube"></div><div class="rankingCard Fill_Flex_Cube"></div><div class="rankingCard Fill_Flex_Cube"></div><div class="rankingCard Fill_Flex_Cube"></div><div class="rankingCard Fill_Flex_Cube"></div><div class="rankingCard Fill_Flex_Cube"></div><div class="rankingCard Fill_Flex_Cube"></div><div class="rankingCard Fill_Flex_Cube"></div><div class="rankingCard Fill_Flex_Cube"></div><div class="rankingCard Fill_Flex_Cube"></div><div class="collapseBtn"><div class="btn">展开更多</div></div><div></div></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "BeijingGiftHome"
}
</script>

<style scoped>
.JColorSearchList-905542 {
  position: relative;
  padding-bottom: 30px;
  overflow: hidden;
}
.JColorSearchList-905542 .clearfix {
  overflow: auto;
  zoom: 1;
}
.JColorSearchList-905542 .filter .f-line {
  padding: 6px 10px;
  background: #F8F8F8;
  zoom: 1;
}
.JColorSearchList-905542 .filter {
  position: relative;
  z-index: 4;
  margin-bottom: 20px;
}
.JColorSearchList-905542 .filter .g-pager .fp-text b, .JColorSearchList-905542 .filter .g-pager .fp-text em, .JColorSearchList-905542 .filter .g-pager .fp-text i {
  font-weight: 400;
  font-style: normal;
}
.JColorSearchList-905542 .filter .g-sort {
  float: left;
}
.JColorSearchList-905542 .filter .g-sort a {
  float: left;
  position: relative;
  padding: 0 10px;
  height: 22px;
  border: 1px solid #e1e1e1;
  margin-right: -1px;
  line-height: 22px;
  background: #FFF;
  color: #333;
}
.JColorSearchList-905542 .filter .g-sort a:hover {
  color: #e4393c;
  border: solid 1px #e4393c;
}
.JColorSearchList-905542 .filter .g-sort a:hover:after {
  content: '';
  width: 1px;
  height: 24px;
  background-color: #e4393c;
  position: absolute;
  right: -1px;
  z-index: 1;
  top: -1px;
}
.JColorSearchList-905542 .filter .g-sort a.jCurrent {
  background-color: #e4393c;
  color: #fff;
}
.JColorSearchList-905542 .filter .g-sort a.jCurrent.up em {
  background: url(//img14.360buyimg.com/cms/jfs/t169/241/1890751726/1114/417d81a4/53be3644N3aaf1af2.gif);
  display: inline-block;
  zoom: 1;
  height: 11px;
  margin-right: 5px;
  width: 9px;
  overflow: hidden;
  vertical-align: middle;
}
.JColorSearchList-905542 .filter .g-sort a.jCurrent.down em {
  background: url(//img13.360buyimg.com/cms/jfs/t187/96/1871186534/1115/3a5d621a/53be3639Nd10f3877.gif);
  display: inline-block;
  zoom: 1;
  height: 11px;
  margin-right: 5px;
  width: 9px;
  overflow: hidden;
  vertical-align: middle;
}
.JColorSearchList-905542  .filter .g-pager {
  float: right;
}
.JColorSearchList-905542 .filter .g-pager .fp-text {
  line-height: 24px;
  margin-right: 10px;
  font-family: verdana;
}
.JColorSearchList-905542 .filter .g-pager .fp-text b {
  color: #e4393c;
}
.JColorSearchList-905542 .filter .g-pager .fp-next,.JColorSearchList-905542 .filter .g-pager .fp-prev, .JColorSearchList-905542 .filter .g-pager .fp-text {
  float: left;
}
.JColorSearchList-905542 .filter .g-pager .fp-next.disabled, .JColorSearchList-905542 .filter .g-pager .fp-prev.disabled {
  padding: 0;
  background-color: #FFF;
  color: #c9c9c9;
  cursor: default;
  border: 1px solid #e1e1e1;
}
.JColorSearchList-905542 .filter .g-pager .fp-prev {
  margin-right: 5px;
}
.JColorSearchList-905542 .filter .g-pager .fp-next, .JColorSearchList-905542 .filter .g-pager .fp-prev {
  width: 38px;
  height: 22px;
  border: 1px solid #999;
  border-radius: 2px;
  background: #FFF;
  line-height: 23px;
  font-family: "\5b8b\4f53";
  text-align: center;
  font-size: 16px;
  color: #333;
}
.JColorSearchList-905542 .filter .f-result-sum {
  float: right;
  height: 24px;
  line-height: 24px;
  margin-right: 10px;
  color: #999;
}
.JColorSearchList-905542 .clr {
  visibility: hidden;
  display: block;
  overflow: hidden;
  clear: both;
  height: 0;
  line-height: 0;
  font-size: 0;
}
.JColorSearchList-905542 .filter .g-search {
  float: right;
  margin-right: 20px;
}
.JColorSearchList-905542 .filter .g-search .btn {
  float: left;
  height: 22px;
  line-height: 22px;
  border-top-right-radius: 11px;
  border-bottom-right-radius: 11px;
  border: solid 1px #e1e1e1;
  border-left: 0;
  width: 26px;
  padding: 0 10px;
  background: #f8f8f8 url(//img11.360buyimg.com/cms/jfs/t3916/243/24176274/1240/f8099125/5837d810N804cc68a.png) no-repeat center;
}
.JColorSearchList-905542 .filter .g-search .input-txt {
  float: left;
  color: #c9c9c9;
  height: 22px;
  line-height: 22px;
  border: 1px solid #e1e1e1;
  padding: 0 10px;
  width: 115px;
  border-top-left-radius: 11px;
  border-bottom-left-radius: 11px;
}
.JColorSearchList-905542 .goods-list {
  height: auto;
  position: relative;
  z-index: 1;
}
.JColorSearchList-905542 .goods-list .gl-warp {
  width: auto;
  height: auto;
  overflow: hidden;
  margin-right: -10px;
}
.JColorSearchList-905542 .goods-list .gl-item {
  width: 190px;
  height: 295px;
  overflow: hidden;
  float: left;
  position: relative;
  z-index: 1;
  margin: 0 10px 20px 0;
}
.JColorSearchList-905542 .goods-list .gl-item .gl-i-wrap {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  background: #fff;
}
.JColorSearchList-905542 .goods-list .gl-item .jPic {
  height: 188px;
  width: 188px;
  border: solid 1px #e1e1e1;
  padding: 0;
  margin-bottom: 5px;
  position: relative;
}
.JColorSearchList-905542 .goods-list .gl-item .jPic a {
  display: block;
  position: relative;
  overflow: hidden;
}

.JColorSearchList-905542 .jScroll{height:29px; margin-bottom:10px; overflow:hidden;}
.JColorSearchList-905542 .jScrollPrev.jCurrent{background-position:-34px -126px; cursor:not-allowed;}
.JColorSearchList-905542 .jScrollPrev{background-position:0 -126px; margin-right:2px;}
.JColorSearchList-905542 .jScrollNext{background-position: -17px -126px;}
.JColorSearchList-905542 .jScrollNext.jCurrent{background-position:-51px -126px; cursor:not-allowed;}
.JColorSearchList-905542 .jScrollBtn{display:none; float:left; height:29px; text-indent:-9999px; width:16px;}
.JColorSearchList-905542 .jScrollBtn{background-image:url("//misc.360buyimg.com/201007/skin/df/i/20130606B.png"); background-repeat:no-repeat;}
.JColorSearchList-905542 .jScrollWrap{float:left; height:29px; overflow:hidden; position:relative; width:156px;}
.JColorSearchList-905542 .jScrollWrap ul{position:absolute; top:0;}
.JColorSearchList-905542 .jScrollWrap li{width:31px; height:31px; float:left; margin:0; padding:0; border:0;}
.JColorSearchList-905542 .jScrollWrap li a{float:left; border:solid 1px #ddd; padding:1px;}
.JColorSearchList-905542 .jScrollWrap li a img{height:25px; height:25px;}
.JColorSearchList-905542 .jScrollWrap li.jCurrent a{border:1px solid #E4393C;}
.JColorSearchList-905542 .jBtnArea {
  position: absolute;
  right: 0;
  top: 35px;
}
.JColorSearchList-905542 .jBtnArea a {
  float: left;
  width: 100px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  background: #ed1c24;
  cursor: pointer;
}
.JColorSearchList-905542 .jGoodsInfo{overflow:hidden;position: relative;zoom: 1;}
.JColorSearchList-905542 .jDesc{height:16px; line-height:16px; overflow:hidden; margin-bottom:5px;}
.JColorSearchList-905542 .jDesc a{font-size:12px; text-decoration:none;color: #666;white-space:nowrap;}
.JColorSearchList-905542 .jSlogan{color:#008700;}
.JColorSearchList-905542 .jPrice{overflow:hidden; margin-bottom:5px; height:15px;line-height:15px;}
.JColorSearchList-905542 .jdPrice{font-size:14px; font-weight:bold; color:#E4393C;}
.JColorSearchList-905542 .d-price-free .jRmb{display: none}
.JColorSearchList-905542 .jdPrice .jdNum{}
.JColorSearchList-905542 .jdPrice .jdStages {
  background: url(//img11.360buyimg.com/cms/jfs/t10759/204/2085617648/1012/751d32c6/59ef0adeNb99d5c49.png) no-repeat right center;
  display: inline-block;
  width: 54px;
  height: 16px;
  padding-left: 5px;
  color: #fff;
  text-align: center;
  vertical-align: top;
}
.JColorSearchList-905542 .jdPrice .jdNumNo{font-size:12px;}
.JColorSearchList-905542 .jdPrice .jdPgPrice{font-size:12px; color: #666; margin-left: 10px; font-weight: 100; font-family: verdana;}

.JColorSearchList-905542 .jExtra{height:16px; line-height:16px; overflow:hidden; padding:2px 0;}
.JColorSearchList-905542 .jExtra a{color:#999; float:left; margin-top:1px; display: none;}
.JColorSearchList-905542 .jExtra a em{color: #005AA0;}
.JColorSearchList-905542 .jExtra span{float:left; height:15px; overflow:hidden;}
.JColorSearchList-905542 .star{margin-right:5px;}
.JColorSearchList-905542 .star .star-white{background:url("//misc.360buyimg.com/201007/skin/df/i/20130606B.png") no-repeat scroll 0 -70px transparent; width:76px;}
.JColorSearchList-905542 .star .star-yellow{background:url("//misc.360buyimg.com/201007/skin/df/i/20130606B.png") no-repeat scroll 0 -86px #FFFFFF; position:relative; z-index:1;}
.JColorSearchList-905542 .star .h1{width:15px;}
.JColorSearchList-905542 .star .h2{width:30px;}
.JColorSearchList-905542 .star .h3{width:45px;}
.JColorSearchList-905542 .star .h4{width:60px;}
.JColorSearchList-905542 .star .h5{width:76px;}
.JColorSearchList-905542 .jPage {
  text-align: right;
}
.JColorSearchList-905542 .jPage a, .JColorSearchList-905542 .jPage span {
  display: inline-block;
  vertical-align: middle;
  padding: 0 10px;
  min-width: 18px;
  height: 34px;
  border: 1px solid #999;
  border-radius: 2px;
  background-color: #fff;
  color: #333;
  text-align: center;
  line-height: 34px;
  font-size: 12px;
}
.JColorSearchList-905542 .jPage a em, .JColorSearchList-905542 .jPage span em {
  font-size: 16px;
  font-family: '\5b8b\4f53';
}
.JColorSearchList-905542 .jPage .jPageCurrent {
  background-color: #333;
  color: #fff;
}
.JColorSearchList-905542 .jPage .jPageDisable {
  border-color: #e1e1e1;
  color: #c9c9c9;
}

</style>
<style scoped>
.colorGoodsSort-922474 {}
.colorGoodsSort-922474 .mc{padding: 15px 15px 0;;font-family: \5FAE\8F6F\96C5\9ED1,arial,\5b8b\4f53;background-color: #fcfcfc;}
.colorGoodsSort-922474 .jOneLevel{overflow:hidden;text-align: center}
.colorGoodsSort-922474 .jOneLevel .jClassi{font-size: 12px;color: #999;font-family: arial,\5FAE\8F6F\96C5\9ED1,\5b8b\4f53;}
.colorGoodsSort-922474 .jOneLevel .jHead {
  position: relative;
  font-size: 22px;
  height: 30px;
  line-height: 30px;
  color: #000;
  padding: 0 20px 15px;
  border-bottom: 1px solid #e1e1e1;
}
.colorGoodsSort-922474 .jOneLevel .jHead .jDottedleft {
  position: absolute;
  display: block;
  left: 20px;
  top: 13px;
  height: 4px;
  width: 4px;
  background: url(//img14.360buyimg.com/cms/jfs/t3448/126/18152604/1049/6f71a7fc/57fd94c0N39f3eb9c.png) no-repeat;
}
.colorGoodsSort-922474 .jOneLevel .jHead  .jDottedRight {
  position: absolute;
  display: block;
  right: 20px;
  top: 13px;
  height: 4px;
  width: 4px;
  background: url(//img14.360buyimg.com/cms/jfs/t3448/126/18152604/1049/6f71a7fc/57fd94c0N39f3eb9c.png) no-repeat;
}
.colorGoodsSort-922474 .jTwoLevel {
  font-size: 14px;
  font-weight: bold;
  height: 45px;
  line-height: 45px;
  overflow: hidden;
  color: #e1e1e1;
  clear: both;
  text-align: center;
  border-bottom: dashed 1px #e1e1e1;
  position: relative;
}
.colorGoodsSort-922474 .jTwoLevel.jNoBorderBottm{border-bottom:0;}
.colorGoodsSort-922474 .jIconArrow {
  display: block;
  width: 20px;
  height: 20px;
  cursor: pointer;
  position: absolute;
  right: 0;
  background: url(//img20.360buyimg.com/cms/jfs/t3442/274/61048783/1064/3b52ecb8/57fd94c0N66bbe258.png) no-repeat center;
  top: 13px;
}
.colorGoodsSort-922474 .current .jIconArrow {
  transform: rotate(90deg);
}
.colorGoodsSort-922474 .jTwoLevel a{
  display: block;
  color: #333;
  overflow: hidden;
}
.colorGoodsSort-922474 .jThreeLevel{overflow:hidden; _height:100%;}

.colorGoodsSort-922474 .jThreeLevel li {
  height: 34px;
  line-height: 34px;
  overflow: hidden;
}

.colorGoodsSort-922474 .jThreeLevel a {
  display: block;
  height: 24px;
  margin-top: 5px;
  line-height: 24px;
  font-size: 14px;
  text-align: center;
  border-radius: 12px;
}

.colorGoodsSort-922474 .jThreeLevel a:hover {
  background-color: #efefef;
  color: #666;
}

</style>
<style scoped>
.page{
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
}
.page-content{
  width: 1262px;
  background: #ffffff;
  border-radius: 20px;
  padding: 20px;
  margin-top: 30px;
}
.left-right-div{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  margin-top: 30px;
}
.left-div{
  margin-right: 20px;
}
.sku-title .tag{
  background: none !important;
}
.black-text, .red-text{
  background: none !important;
}
.main-price .tag.bybt-text, .V_mj6kdogj__floors_CommonRanking_components_PC_CardList .rankingCard .right .price-area .sub-price .tag.bybt-text {
  font-size: 14px;
  background: #fe4d01;
  color: #fff;
  padding: 3px 4px;
  border-radius: 2px;
}
.tag {
  display: inline-block;
  padding: 0 10px;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  color: #05305E;
  height: 20px;
  line-height: 20px;
}
.sku-img{
  position: relative !important;
}
</style>
<style scoped lang="css" src="./hot/main.82997b33.css" />
